import React from 'react';
import styled from 'styled-components';
import { theme, media, color } from '../theme';

export const PlayButton = () => (
  <Button />
);

const Button = styled.span`
  background-color: ${theme.playButtonBackgroundColor};
  border-radius: 50%;
  display: inline-block;
  height: 60px;
  width: 60px;
  position: relative;
  cursor: pointer;
  transition: ${theme.transitionShortAndFunction};
  box-shadow: 0 5px 10px ${theme.playButtonShadow};

  &:hover {
    background-color: ${theme.playButtonBackgroundColorFocus};

    &:after {
      /* opacity: .5; */
      /* border-left-color: ${theme.playButtonBackgroundColor}; */
    }
  }

  &:after {
    content: "";
    display: block;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 10px 0 10px 20px;
    border-color: transparent transparent transparent ${theme.playButtonIconColor};
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-40%, -50%);
  }
`;
